var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-row',{attrs:{"type":"flex","vs-justify":"center","vs-align":"center"}},[_c('iframe',{ref:"frameTester",attrs:{"id":"frameTester","src":_vm.frameTesterUrl},on:{"load":_vm.setFrameLoaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }